import { render } from "./ForgotPasswordModal.vue?vue&type=template&id=7680d5bd"
import script from "./ForgotPasswordModal.vue?vue&type=script&lang=ts"
export * from "./ForgotPasswordModal.vue?vue&type=script&lang=ts"
script.render = render

export default script